import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function TikTokIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="-7 -3 32 38" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3806 0C20.9193 4.39934 23.5048 7.0222 28.0001 7.30123V12.2493C25.395 12.4911 23.113 11.682 20.459 10.1566V19.411C20.459 31.1674 6.96334 34.8413 1.53767 26.4146C-1.94887 20.9922 0.186146 11.4773 11.3705 11.096V16.3138C10.5184 16.444 9.60762 16.6487 8.77516 16.9184C6.28758 17.7183 4.8773 19.2157 5.26904 21.8572C6.02315 26.9169 15.7972 28.4143 14.9843 18.5275V0.00930093H20.3806V0Z"
      />
    </SvgIcon>
  );
}
